
<div class="c-section grey detail-view-form-list-filters">
  <row>
    <column>
      <row>
        <column>

          <div class="container">
            <label for="submission-start-date-filter">Submission Date Start</label>
            <date-picker id="submission-start-date-filter"
                         v-model="submissionStartDate"
                         :mode="DatetimeMode.Date"
                         @input="triggerUpdate"
                         allow-input
                         :id="`form-list=${contentElement.client_id}-submission-start-date-filter`"></date-picker>
          </div>
        </column>
        <column>
          <div class="container">
            <label for="submission-end-date-filter">Submission Date End</label>
            <date-picker id="submission-end-date-filter"
                         v-model="submissionEndDate"
                         :mode="DatetimeMode.Date"
                         @input="triggerUpdate"
                         allow-input
                         :id="`form-list=${contentElement.client_id}-submission-end-date-filter`"></date-picker>
          </div>
        </column>
      </row>
    </column>
    <column>
      <row class="align-items-end">
        <column size="370">
          <div class="container">
            <label for="selected-form-a-select">Form</label>
            <a-select id="selected-form-a-select"
                      @input="triggerUpdate"
                      v-model="selectedFormId"
                      :options="linkedFormOptions"></a-select>
          </div>
        </column>
        <column class="align-right">
          <div class="container mb-3">
            <button type="button" class="btn blue" @click="clearFilters">Clear Filters</button>
          </div>
        </column>
      </row>
    </column>
  </row>
</div>
